import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import { allpayments } from 'models/allpayments'; // Importing allpayments model
import { devConfig } from 'config/config'; // Importing development configuration

/**
 * Class representing the blockchainNetwork table view.
 * @extends JetView
 */
export default class tableBlockchainNetworksView extends JetView {
    /**
     * Configures the layout of the view.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const dateFormat = webix.Date.dateToStr(this.app.config.dateFormat); // Date formatting function
        return {
            rows: [
                {
                    id: 'preloader', // ID for the preloader
                    cols: [
                        {
                            view: 'datatable', // DataTable view
                            id: 'datatable', // ID for the datatable
                            css: 'webix_header_border webix_data_border webix_footer_border', // CSS classes for styling
                            select: true, // Enable row selection
                            scrollY: true, // Enable vertical scrolling
                            columns: [
                                {
                                    id: 'rating',
                                    header: 'Acciones',
                                    width: 100,
                                    height: 25,
                                    template: function (obj) {
                                        let content = '';

                                        if (devConfig.getPermAction('BlockchainNetworksView', 'Edit')) {
                                            content += "<span class='webix_icon wxi-search view' style='margin-right:8px; cursor:pointer;'></span>";
                                        }

                                        if (devConfig.getPermAction('BlockchainNetworksEdit', 'Edit')) {
                                            content += "<span class='webix_icon wxi-close edit'></span>";
                                        }

                                        // Si hay al menos un ícono, centramos el contenedor
                                        if (content) {
                                            return "<div style='display:flex; justify-content:center; align-items:center; height:100%'>" + content + "</div>";
                                        } else {
                                            return '';
                                        }
                                    }
                                },
                                {
                                    id: 'id', // Column ID
                                    header: _('Id de Red'), // Localized column header
                                    width: 300, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'name', // Column ID
                                    header: _('Nombre de Red'), // Localized column header
                                    width: 300, // Column width
                                    sort: 'string', // Sorting type
                                },
                                {
                                    id: 'code', // Column ID
                                    header: _('Código de Red'), // Localized column header
                                    width: 450, // Column width
                                    sort: 'int', // Sorting type
                                },
                                {
                                    id: 'state', // Column ID
                                    header: _('Estado'), // Localized column header
                                    editor: 'combo', // Combo editor for this column
                                    options: [
                                        // Options for the combo editor
                                        { id: 'A', value: _('Activa') }, // Active option
                                        { id: 'I', value: _('Inactiva') }, // Inactive option
                                    ],
                                    width: 400, // Column width
                                    sort: 'int', // Sorting type
                                },
                            ],
                            onClick: {
                                // Event handler for click events
                                edit: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$("editform").setValues(item); // Set form values to the clicked item
                                    // Edit icon click event
                                    $$('editwinBlockchainNetworks').show(); // Show edit window
                                },

                                view: function (euv, id) {
                                    var item = this.getItem(id); // Get the clicked item
                                    $$("viewform").setValues(item); // Set form values to the clicked item
                                    // Edit icon click event
                                    $$('viewwinBlockchainNetworks').show(); // Show edit window
                                },
                            },
                            math: true, // Enable math operations
                            loadahead: devConfig.getDefaultDataFetch(), // Load ahead configuration
                            pager: 'pagerA', // Pager ID
                        },
                    ],
                },
            ],
        };
    }

    /**
     * Initializes the view and binds events.
     * @param {Object} grid - The grid object to initialize.
     */
    init(grid) {
        const _ = this.app.getService('locale')._; // Localization service
        grid = $$('datatable'); // Reference to the datatable
        var url = devConfig.geturlApi() + 'BlockChains/GetBlockChains'; // API URL for fetching blockchainNetworks
        var filter = ''; // Filter string for data loading
        var popup = webix.ui({
            // Popup window for editing providers
            view: 'window',
            id: 'editwinBlockchainNetworks', // ID for the edit window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 350 : 200, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Editar Red Blockchain') }, // Label for editing blockchainNetwork
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close button click event
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for editing banblockchainNetwork details
                    id: 'editform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for Name
                            label: _('Nombre de Red'),
                            name: 'name', // Name for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            view: 'text', // Text input for Name
                            label: _('Código de Red'),
                            name: 'code', // Name for the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                            required: true, // Required field
                        },
                        {
                            view: 'combo', // Combo input for State
                            label: _('Estado'),
                            name: 'state', // Name for the input
                            required: true, // Required field
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activa') }, // Active option
                                { id: 'I', value: _('Inactiva') }, // Inactive option
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        // Cancel button click event
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Save button click event
                                        var values = $$('editform').getValues(); // Get form values
                                        var form = $$('editform');

                                        if (!form.validate()) {
                                            webix.message({ type: "error", text: _("Por favor, completa todos los campos obligatorios.") });
                                            return;
                                        }
                                        webix
                                            .ajax() // AJAX request to save changes
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'BlockChains/UpdateBlockChains', // API URL for updating blockchainNetworks
                                                '{"Id":"' +
                                                values.id +
                                                '","state":"' +
                                                values.state +
                                                '","code":"' +
                                                values.code +
                                                '","name":"' +
                                                values.name +
                                                '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Cell value was changed', // Success message on success
                                                        );
                                                        grid.clearAll(); // Clear the grid
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        $$('editform').setValues(
                                            $$('editform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupView = webix.ui({
            // Popup window for editing providers
            view: 'window',
            id: 'viewwinBlockchainNetworks', // ID for the edit window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 350 : 200, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Visualización Red Blockchain') }, // Label for editing blockchainNetwork
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close button click event
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for editing banblockchainNetwork details
                    id: 'viewform', // ID for the edit form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for Name
                            label: _('Nombre de Red'),
                            name: 'name', // Name for the input
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'text', // Text input for Name
                            label: _('Código de Red'),
                            name: 'code', // Name for the input
                            readonly: true, // Read-only field
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            view: 'combo', // Combo input for State
                            label: _('Estado'),
                            name: 'state', // Name for the input
                            readonly: true, // Read-only field
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activa') }, // Active option
                                { id: 'I', value: _('Inactiva') }, // Inactive option
                            ],
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            labelWidth: 150, // Label width
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cerrar'),
                                    click: function () {
                                        // Cancel button click event
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        var popupAdd = webix.ui({
            // Popup window for adding blockchainNetworks
            view: 'window',
            id: 'AddBlockchainNetworks', // ID for the add window
            autowidth: screen.width < 500 ? 350 : 450, // Width based on screen size
            minHeight: screen.width < 500 ? 350 : 200, // Height based on screen size
            autoheight: true, // Auto height based on content
            head: {
                view: 'toolbar', // Toolbar for the window header
                cols: [
                    { view: 'label', label: _('Registro de Red Blockchain') }, // Label for adding blockchainNetwork
                    {
                        view: 'icon', // Close icon
                        icon: 'wxi-close',
                        click: function () {
                            // Close button click event
                            this.getTopParentView().hide(); // Hide the popup
                        },
                    },
                ],
            },
            position: 'center', // Center position of the window
            modal: true, // Modal window
            body: {
                view: 'scrollview', // Scrollable view
                scroll: 'y', // Vertical scrolling
                body: {
                    view: 'form', // Form for adding blockchainNetwork details
                    id: 'addform', // ID for the add form
                    width: screen.width < 500 ? 350 : 450, // Width based on screen size
                    elements: [
                        {
                            view: 'text', // Text input for Name
                            label: _('Nombre de Red'),
                            name: 'name', // Name for the input
                            labelWidth: 180,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            required: true, // Required field
                        },
                        {
                            view: 'text', // Text input for Name
                            label: _('Código de Red'),
                            name: 'code', // Name for the input
                            labelWidth: 180,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            required: true, // Required field

                        },
                        {
                            view: 'combo', // Combo input for State
                            label: _('Estado'),
                            name: 'state', // Name for the input
                            options: [
                                // Options for the combo
                                { id: 'A', value: _('Activa') }, // Active option
                                { id: 'I', value: _('Inactiva') }, // Inactive option
                            ],
                            labelWidth: 180,   // space reserved for the label
                            inputWidth: 410,   // width of the input
                            labelPosition: screen.width < 500 ? 'top' : 'left', // Label position based on screen size
                            required: true, // Required field
                        },
                        {
                            cols: [
                                // Button layout
                                {
                                    view: 'button', // Cancel button
                                    value: _('Cancelar'),
                                    click: function () {
                                        // Cancel button click event
                                        this.getTopParentView().hide(); // Hide the popup
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                    },
                                },
                                {
                                    view: 'button', // Save button
                                    type: 'form',
                                    value: _('Guardar'),
                                    click: function ($e) {
                                        // Save button click event
                                        var values = $$('addform').getValues(); // Get form values
                                        var form = $$('addform');

                                        if (!form.validate()) {
                                            webix.message({ type: "error", text: _("Debe completar todos los campos requeridos") });
                                            return;
                                        }

                                        webix
                                            .ajax() // AJAX request to save new cryptocurrency
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'BlockChains/CreateBlockChains', // API URL for creating blockchainNetworks
                                                '{"state":"' + values.state + '","name":"' + values.name + '","code":"' + values.code + '"}', // JSON payload
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Error! ', // Error message on failure
                                                        );
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        webix.message(
                                                            'Cell value was changed', // Success message on success
                                                        );
                                                        grid.clearAll(); // Clear the grid
                                                        grid.load(
                                                            url + '?start=0&count=' + grid.data.$pagesize + filter, // Reload grid data
                                                        );
                                                    },
                                                },
                                            );
                                        $$('addform').setValues(
                                            $$('addform').getCleanValues(), // Reset form values
                                        );
                                        this.getTopParentView().hide(); // Hide the popup
                                    },
                                },
                            ],
                        },
                    ],
                },
            },
        });
        this.on(this.app, 'addBlockchains:button', (filter) => {
            // Event listener for adding blockchainNetworks
            popupAdd.show(); // Show add blockchainNetwork popup
        });
        this.on(this.app, 'blockchainNetworks:filter', (filterData) => {
            // Event listener for filtering blockchainNetworks
            var object = Object.entries(filterData); // Convert filter data to entries
            var string1 = ''; // Initialize filter string
            for (var i = 0; i < object.length; i++) {
                // Iterate through filter data
                if (typeof object[i][1] !== 'object' && object[i][1] !== '') {
                    // Check for non-object and non-empty values
                    if (object[i][0] == 'Datepicker') {
                        // Handle datepicker filter
                        var date = object[i][1].split(' - '); // Split date range
                        console.log(date); // Log date range
                        string1 = string1 + '&dateFrom=' + date[0]; // Add dateFrom to filter string
                        string1 = string1 + '&dateTo=' + date[1]; // Add dateTo to filter string
                    } else {
                        string1 = string1 + '&' + object[i][0] + '=' + object[i][1]; // Add other filters to string
                    }
                } else {
                    if (typeof object[i][1] === 'object') {
                        // Handle object filters
                        var object2 = Object.entries(object[i][1]); // Convert object to entries
                        for (var j = 0; j < object2.length; j++) {
                            // Iterate through object entries
                            if (object2[j][1] !== null) {
                                // Check for non-null values
                                if (object2[j][0] === 'start') {
                                    // Handle start date
                                    var d = new Date(object2[j][1]); // Create date object
                                    var dateFrom =
                                        'dateFrom=' +
                                        d.getFullYear() +
                                        ':' +
                                        ('00' + (d.getMonth() + 1)).slice(-2) +
                                        ':' +
                                        ('00' + d.getDate()).slice(-2) +
                                        ' ' +
                                        ('00' + d.getHours()).slice(-2) +
                                        ':' +
                                        ('00' + d.getMinutes()).slice(-2) +
                                        ':' +
                                        ('00' + d.getSeconds()).slice(-2); // Format dateFrom
                                    string1 = string1 + '&' + dateFrom; // Add dateFrom to filter string
                                } else {
                                    if (object2[j][0] === 'end') {
                                        // Handle end date
                                        var d = new Date(object2[j][1]); // Create date object
                                        var dateTo =
                                            'dateTo=' +
                                            d.getFullYear() +
                                            ':' +
                                            ('00' + (d.getMonth() + 1)).slice(-2) +
                                            ':' +
                                            ('00' + d.getDate()).slice(-2) +
                                            ' ' +
                                            ('00' + d.getHours()).slice(-2) +
                                            ':' +
                                            ('00' + d.getMinutes()).slice(-2) +
                                            ':' +
                                            ('00' + d.getSeconds()).slice(-2); // Format dateTo
                                        string1 = string1 + '&' + dateTo; // Add dateTo to filter string
                                    }
                                }
                            }
                        }
                    }
                }
            }
            grid.clearAll(); // Clear the grid
            grid.load(url + '?start=0&count=' + grid.data.$pagesize + string1); // Load filtered data
            filter = string1; // Update filter variable
        });
        grid.attachEvent('onAfterSort', function (by, dir, as) {
            // Event handler for sorting
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + filter + '&sort[' + by + ']=' + dir, // Load sorted data
            );
        });
        grid.attachEvent('onItemClick', function (id, e, node) {
            // Event handler for item click
            var item = this.getItem(id); // Get clicked item
            this.$scope.app.callEvent('user:id', [item.Id]); // Trigger user ID event
        });
        grid.attachEvent('onItemDblClick', function (id, e, node) {
            // Event handler for item double click
            var item = this.getItem(id); // Get double-clicked item
            popup.show(); // Show edit popup
        });
        this.on(this.app, 'player:select', (Id) => {
            // Event listener for player selection
            grid.load(
                url + '?start=0&count=' + grid.data.$pagesize + '&PlayerId=' + Id, // Load data for selected player
            );
        });
        $$('editform').bind($$('datatable')); // Bind edit form to datatable
    }
}

// FILE DOCUMENTED
